<script setup lang="ts">
import type { IUser } from '@/interfaces';
import type { PropType } from 'vue';
import { flare } from '@flareapp/js';

const props = defineProps({ user: { required: true, type: Object as PropType<IUser> } });
flare.addContextGroup('user', props.user);
</script>
